import { render, staticRenderFns } from "./AccountTagFilter.vue?vue&type=template&id=48a63867&"
import script from "./AccountTagFilter.vue?vue&type=script&lang=js&"
export * from "./AccountTagFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports